import { render, staticRenderFns } from "./AttendencePlaceAlterModal.vue?vue&type=template&id=c021a8a2"
import script from "./AttendencePlaceAlterModal.vue?vue&type=script&lang=js"
export * from "./AttendencePlaceAlterModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports